<app-navbar [title]="pageTitle">
	<button class="btn btn-warning me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="deleteAsk()">
		Usuń
	</button>
	<button
		class="btn btn-primary me-3"
		*ngIf="(pageFunction === 'edit' && editable) || pageFunction === 'add'"
		(click)="submit()"
	>
		Zapisz
	</button>
	<button class="btn btn-primary me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="editUnlock()">
		Edycja
	</button>
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container my-4">
	<form (submit)="submit()">
		<fieldset
			[disabled]="pageFunction !== 'add' && !editable"
			class="tab-pane fade active show"
			id="general"
			role="tabpanel"
		>
			<div class="form-floating mb-3">
				<input
					type="text"
					class="form-control"
					id="name"
					name="name"
					[(ngModel)]="data.name"
					placeholder="Imię"
					required
				/>
				<label for="name">Nazwa</label>
			</div>
			<app-checkboxes [items]="rights" [(values)]="data.rights"></app-checkboxes>
		</fieldset>
	</form>
</div>
